import { render, staticRenderFns } from "./sitelocation.vue?vue&type=template&id=66c87bb1&scoped=true"
import script from "./sitelocation.vue?vue&type=script&lang=js"
export * from "./sitelocation.vue?vue&type=script&lang=js"
import style0 from "./sitelocation.vue?vue&type=style&index=0&id=66c87bb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c87bb1",
  null
  
)

export default component.exports